import React, { useState, useEffect } from "react";
import { ActualizarClaseActividades } from "../../../components/hacienda/actividadEconomica/modalActualizarClasificador";
import { ValidCaptcha } from "../../../util/varios";
import { MensajeCapcha } from "../../../components/mensajes";
import { Mensaje, MensajeSiNo } from "../../../components/mensajes2";
import { Dimmer } from "../../../components/spinner";
import useTable from "../../useTable";
import axios from "axios";
import { Toasts } from "../../toasts";
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";
import CardsModule from "../../cartas";

const headCells = [
  {
    id: "codigociu",
    label: "CODIGO CIU",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "codigoactividad",
    label: "CODIGO ACT.",
    width: "120px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "anios",
    label: "AÑO",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "idactividad",
    label: "ID",
    width: "50px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "120px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
];

function TablaClaseActividad(props) {
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));

  const [titulo1] = useState();
  const [msg1] = useState();
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [persona, setPersona] = useState();
  const [statusCome] = useState();
  const [actividad, setActividad] = useState();
  const [inmuebleCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [deshabilitado] = useState(false);
  const permiso = JSON.parse(localStorage.getItem("accactividad"));
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.codigociu.includes(target.value) === null
                ? ""
                : x.codigociu.includes(target.value)) ||
              (x.codigoactividad === null
                ? ""
                : x.codigoactividad
                  .toLowerCase()
                  .includes(target.value.toLowerCase())) ||
              (x.anios === null
                ? ""
                : x.anios.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.descripcion === null
                ? ""
                : x.descripcion
                  .toLowerCase()
                  .includes(target.value.toLowerCase())) ||
              (x.idactividad === null
                ? ""
                : x.idactividad.includes(target.value))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let campos =
      "actualizada,codigociu, codigoactividad,anios, TRIM(descripcion) AS descripcion, idactividad";

    let nomtab = "actividad";
    let condi = "anios=" + anioactu;
    let orden = "idactividad desc";
    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          console.log(response.data);

          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);

        setActivate(false);
      });
  };

  const seleccionarRegistro = (id) => {
    setActivate(true);
    let endpoint = op.conexion + `/api/industria/actividad?idactividad=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActividad(response.data);
          setMostrar5(true);
          setActivate(false); 1
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);

        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setActividad();
    setUsuariow();
    setPersona();
    setMostrar5(false);
  };

  const validarActuActividad = () => {
    setActividad();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    if (operacion === 4) {
      return;
    }
    renderizar();
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const validarCapcha = () => {
    var valido = ValidCaptcha();
    if (valido) {
      setMostrar4(false);
    }
  };

  const cerrarModal = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };

  const handleCancelaCapcha = () => {
    setMostrar4(false);
  };

  const handleCloseSi = () => {
    setActividad();
    procesarSolicitud();
  };

  const procesarSolicitud = () => {
    event.preventDefault();
  };
  const renderizar = () => {
    seleccionarActividades();
  };
  const seleccionarActividades = () => {
    setActivate(true);
  };
  const consultarActividad = (op, id, permiso) => (event) => {
    setOperacion(op);
    event.preventDefault();
    if (permiso === "1") {
      if (op === 1) {
        setMostrar5(true);
      } else {
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        titulo: "Notificación",
        mensaje:
          op === 1
            ? "No posee permiso para registrar un Clasificador de actividades Economicas"
            : op === 2
              ? "No posee permiso para editar un Clasificador de actividades Economicas"
              : op === 3
                ? "No posee permiso para eliminar un Clasificador de actividades Economicas"
                : "No posee permiso para consultar un Clasificador de actividades Economicas",
      });
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };
  const activeCount = records.filter((r) => r.actualizada).length;
  const inactiveCount = records.filter((r) => !r.actualizada).length;

  return (
    <div className="col-8 m-0 p-2 mx-auto mt-5 rounded">
      <CardsModule
        total={records.length}
        title2={'Actualizadas'}
        title3={'No Actualizadas'}

        activos={activeCount}
        inactivos={inactiveCount}
      />
      <div className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
        <div className="col-md-7">
          <h3>Gestion de Clasificadores Actividaes Economicas</h3>
        </div>
        <div className="col-md-3 d-flex justify-content-end">
          <a type="button" onClick={cerrar} className="text-light ">
            <i className="fas fa-times mx-2"></i>
            <span className="fw-bold">Salir</span>
          </a>
        </div>
      </div>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-6 col-lg-4 m-0 p-0">
          <SearchInput
            type="search"
            placeholder="Buscar"
            onChange={handleSearch}
          />
        </div>
        <div className="col-auto m-0 p-0">
          <PrimaryButton icon="fa-plus m-0"
            onClick={consultarActividad(1, "", permiso.toString().substring(1, 2))}
            disabled={permiso.toString().substring(1, 2) !== "1"}
          />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item) => (
                <tr key={item.idactividad} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center" }}
                  >
                    {item.codigociu}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center" }}
                  >
                    {item.codigoactividad}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center" }}
                  >
                    {item.anios}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "left", maxWidth: "300px" }}
                  >
                    {item.descripcion}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center" }}
                  >
                    {item.idactividad}
                  </td>
                  <td
                    align="center"
                    className="align-baseline"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      onClick={consultarActividad(
                        4,
                        item.idactividad,
                        permiso.toString().substring(0, 1)
                      )}
                      title="Consultar Actividad "
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-pill"
                          : "btn btn-sm btn-secondary rounded-pill"
                      }
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarActividad(
                        2,
                        item.idactividad,
                        permiso.toString().substring(2, 3)
                      )}
                      title="Editar Actividad"
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-pill"
                          : "btn btn-sm btn-secondary rounded-pill"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarActividad(
                        3,
                        item.idactividad,
                        permiso.toString().substring(3, 4)
                      )}
                      title="Elliminar Actividad"
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-pill"
                          : "btn btn-sm btn-secondary rounded-pill"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ActualizarClaseActividades
        show={mostrar5}
        titulo={titulo1}
        mensaje={msg1}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuActividad}
        onHideRenderizar={seleccionarRegistros}
        actividad={actividad}
        statuscome={statusCome}
        usuarioweb={usuariow}
        actividadcome={actividad}
        representante={persona}
        inmueble={inmuebleCome}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        operacion={operacion}
      />

      <MensajeCapcha
        show={mostrar4}
        onHideAcepta={validarCapcha}
        onHideCancela={handleCancelaCapcha}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
}

export default TablaClaseActividad;
